import { useContext, useEffect, useState } from "react";
import { debounce } from "lodash";

import { StickyContext } from "./withStickyContextProvider";

const footerSelector = ".jsFooterContainer";

const isAppFooterInView = () => {
  const footer = document.querySelector(footerSelector);
  if (!footer) {
    return false;
  }
  const footerPositionTop = footer.offsetTop;
  const viewBottom = window.scrollY + window.innerHeight;
  return viewBottom > footerPositionTop;
};

export const useSticky = isMobile => {
  const { desktop, mobile } = useContext(StickyContext);
  const { setValue, value } = isMobile ? mobile : desktop;
  const [appFooterInView, setAppFooterInView] = useState(isAppFooterInView());
  const stickyValue = isMobile ? !appFooterInView && value : value;

  const handleSetFooterInView = debounce(() => {
    setAppFooterInView(isAppFooterInView());
  });

  useEffect(() => {
    if (isMobile) {
      window.addEventListener("scroll", handleSetFooterInView, false);
    }

    return () => {
      window.removeEventListener("scroll", handleSetFooterInView);
    };
  }, [isMobile]);

  return [stickyValue, setValue];
};

export const findMountPoint = ({ isMobile, isOnTopOfContent }) =>
  isMobile || isOnTopOfContent
    ? document.body
    : document.querySelector(".HeaderBlock .Header");

export const transitionSticky = (value, container) => {
  if (value) {
    container.classList.add("active");
  } else {
    container.classList.remove("active");
  }
};

export const useStickyContainer = (isMobile, container) => {
  const [value, setValue] = useSticky(isMobile);

  useEffect(() => {
    if (container) {
      transitionSticky(value, container);
    }
  }, [value, isMobile, container]);

  return [value, setValue];
};
